import { useEffect } from 'react';

import { DashboardBanner } from 'dash-ui';

import { useCreateDashboardNotifications } from 'common/hooks/useCreateDashboardNotifications/useCreateDashboardNotifications';

function NotificationBanner() {
  const { showNotificationsBanners } = useCreateDashboardNotifications();

  useEffect(() => {
    showNotificationsBanners();
  }, [showNotificationsBanners]);

  return <DashboardBanner mb={4} />;
}

export default NotificationBanner;
